// The four instrument groups and their colours, defined once.
//
// Russell's mapping, confirmed 2026-09-26: Melodies purple, Drums blue,
// Textures yellow, Sound FX green. The backend derives `color_pack` from
// `instrument_group` in SQL so the name and the colour cannot disagree; this is
// the front-end half of the same contract. Anything that paints a group reads it
// from here rather than keeping its own copy, because two copies of a colour map
// is how a group ends up one colour on a card and another in a heading.

export const INSTRUMENT_GROUPS = ['Melodies', 'Drums', 'Textures', 'Sound FX'];

export const GROUP_COLOR_NAME = {
  Melodies: 'Purple',
  Drums: 'Blue',
  Textures: 'Yellow',
  'Sound FX': 'Green',
};

// Tailwind's default shades. Keep the raw values here for places where a CSS
// class cannot be used, such as proportional pack bars.
export const GROUP_HEX = {
  Melodies: '#A855F7',
  Drums: '#3B82F6',
  Textures: '#FACC15',
  'Sound FX': '#22C55E',
};

// Card surface: translucent fill plus a matching border.
export const COLOR_PACK_SURFACE = {
  Purple: 'bg-purple-500/20 border-purple-500/50',
  Blue: 'bg-blue-500/20 border-blue-500/50',
  Yellow: 'bg-yellow-400/20 border-yellow-400/50',
  Green: 'bg-green-500/20 border-green-500/50',
};

// Foreground, for section headings and icons.
export const COLOR_PACK_TEXT = {
  Purple: 'text-purple-500',
  Blue: 'text-blue-500',
  Yellow: 'text-yellow-400',
  Green: 'text-green-500',
};

// Solid swatch, for legends and group dots.
export const COLOR_PACK_DOT = {
  Purple: 'bg-purple-500',
  Blue: 'bg-blue-500',
  Yellow: 'bg-yellow-400',
  Green: 'bg-green-500',
};

export const surfaceForGroup = (group) =>
  COLOR_PACK_SURFACE[GROUP_COLOR_NAME[group]] || 'bg-card/50 border-white/10';

export const textForGroup = (group) =>
  COLOR_PACK_TEXT[GROUP_COLOR_NAME[group]] || 'text-muted-foreground';

export const dotForGroup = (group) =>
  COLOR_PACK_DOT[GROUP_COLOR_NAME[group]] || 'bg-white/20';
